/**
 * Created by Roman on 2014-09-22.
 */


angular.module('flipto.components.fieldEditors')
    .config(['$provide', '$compileProvider', function ($provide, $compileProvider) {

        $compileProvider.directive('ftTextareaField', [function () {
            return {
                restrict: 'E',
                scope: {
                    'datasource': '='
                },
                templateUrl: '/app/components/field-editors/textAreaField.html',
                link: function (scope, elem, attrs) {
                    scope.isMultiLanguage = angular.isArray(scope.datasource);
                    scope.languages = scope.isMultiLanguage ? scope.datasource : [];
                    scope.fields = adjustFields(scope.$eval(attrs.fields) || []);
                    scope.required = (angular.isDefined(attrs.required) && attrs.required!=='false') || false;
                    scope.minLength = attrs.ngMinlength && scope.$eval(attrs.ngMinlength) || 0;
                    scope.maxLength = attrs.ngMaxlength && scope.$eval(attrs.ngMaxlength) || 1073741824; //1024^3
                    if(angular.isDefined(attrs.height)){
                        var height = scope.$eval(attrs.height);
                        scope.inlineStyle = {"max-height": "none", "height": height + "px"};
                    }

                    /**
                     * Returns fields array as objects
                     * @param fields
                     * @returns {Array}
                     */
                    function adjustFields(fields) {
                        return _.map(fields, function (field) {
                            if (angular.isString(field) == true) {
                                return {name: field, label: null};
                            }
                            return field;
                        });
                    }
                }
            };
        }]);
    }]);